/**
 * MIN-242: the gutter panel's "expand to full page" action takes the
 * conversation already open to the full-page route. Given the active thread
 * id (including `0`, a valid thread id — hence the `null` check rather than
 * falsiness), decide the navigate target: a real thread lands on that
 * thread's full-page route; no active thread lands on the composer (the
 * `/chat` index).
 */
export type ExpandDestination<T = string> = { to: "/chat/$threadId"; params: { threadId: T } } | { to: "/chat" };

export function resolveExpandDestination<T>(activeThreadId: T | null): ExpandDestination<T> {
  if (activeThreadId === null) return { to: "/chat" };
  return { to: "/chat/$threadId", params: { threadId: activeThreadId } };
}
